import { useState, createContext } from "react";
import Modal from "../Modal";
import { DisplayApproval } from "./DisplayApproval";
import { styled } from "@mui/material";
import Header from "../../../../customs/Header";

export const ApprovalContext = createContext<any>({});

function Approvals() {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalView, setModalView] = useState<any>("view");
  const [modalData, setModalData] = useState<any>(null);
  const [routeName, setRouteName] = useState("Examination / NYSC");
  const [examEntryLevel, setExamEntryLevel] = useState<any>();

  const ApprovalContextProvider = {
    setShowModal,
    setModalView,
    setModalData,
    modalData,
    setRouteName,
    setExamEntryLevel,
  };

  const [openBatchApprovalModal, setOpenBatchApprovalModal] = useState(false);

  const handleOpenBatchApproval = () => {
    setOpenBatchApprovalModal(true);
  };

  const handleCloseBatchApproval = () => {
    setOpenBatchApprovalModal(false);
  };

  return (
    <>
      <ApprovalContext.Provider value={ApprovalContextProvider}>
        <Header
          props={{
            firstName: `${routeName} / Awaiting Approval`,
            secondName: "Approval",
            buttonText: "Batch Approval",
          }}
          handleOpen={handleOpenBatchApproval}
        />
        
        <ApprovalContainer>
          <DisplayApproval
            entryLevelData={examEntryLevel}
            setRouteName={setRouteName}
            showBatchApprovalModal={openBatchApprovalModal}
            handleCloseBatchApproval={handleCloseBatchApproval}
          />
          
          <Modal
            showModal={showModal}
            setShowModal={setShowModal}
            modalView={modalView}
            data={modalData}
            entryLevelData={examEntryLevel}
          />
        </ApprovalContainer>
      </ApprovalContext.Provider>
    </>
  );
}

export default Approvals;

const ApprovalContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 48px 20px;
`;
